import { HashLink as Link } from 'react-router-hash-link';
import Cards from '../Components/Card.js';
import ReviewCards from '../Components/ReviewCards.js';

export default function Home() {
    return (
        <div>
            <div className='landing-message'>
                <h1 className='message-statement'>COMPUTER LAPTOP & PRINTER REPAIRS</h1>
                <h2 className='message-guarantee' style={{margin: '0px auto'}}>GAMING PC SPECIALISTS</h2>
                <h2 className='message-statement' style={{fontSize : '26px', fontStyle: 'italic' }}>SERVING THE WIRRAL FOR 27 YEARS</h2>               
                <h2 className='message-guarantee' style={{margin: '0px auto'}}>ALWAYS A FREE ESTIMATE - NO FIX NO FEE</h2>
            </div>
            <h1>Explore our Services</h1>
          
            <Cards />
            <div className='get-in-touch'>
                <h2 style={{maxWidth: '500px', fontSize : '18px'}}>IF YOU HAVE ANY QUESTIONS OR WOULD LIKE MORE INFORMATION ON A REPAIR PLEASE CLICK BELOW</h2>
                <Link to="/contact#c-form" ><button className='get-in-btn'>Contact Us</button></Link>                
            </div>
            <h2>See What Our Customers Say</h2>
            <ReviewCards />
        </div>
    );
}